"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.DOMBlock = exports.makeUntilRefresh = exports.getRefreshEvent$ = exports.DEFAULT_LOAD_EVENT = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
exports.DEFAULT_LOAD_EVENT = "dcContentReplaced";
var getRefreshEvent$ = function (ev) {
    if (ev === void 0) { ev = exports.DEFAULT_LOAD_EVENT; }
    return (0, rxjs_1.fromEvent)(window, ev).pipe((0, operators_1.share)());
};
exports.getRefreshEvent$ = getRefreshEvent$;
function makeUntilRefresh(refresh$) {
    if (refresh$ === void 0) { refresh$ = null; }
    var event$ = refresh$ || (0, exports.getRefreshEvent$)();
    return function (sub) {
        return sub.pipe((0, operators_1.takeUntil)(event$));
    };
}
exports.makeUntilRefresh = makeUntilRefresh;
function DOMBlock(config) {
    var selector = config.selector, _a = config.isElementArray, isElementArray = _a === void 0 ? false : _a, _b = config.loadEvent, loadEvent = _b === void 0 ? exports.DEFAULT_LOAD_EVENT : _b, _c = config.loadEventSource, loadEventSource = _c === void 0 ? window : _c, _d = config.loadEventOptions, loadEventOptions = _d === void 0 ? {} : _d;
    if (!(selector === null || selector === void 0 ? void 0 : selector.length))
        throw new Error('You need at least 1 char in the selector!');
    return function (Class) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                _this.$elements = [];
                // @deprecated
                _this.domRefresh$ = (0, exports.getRefreshEvent$)(); // todo: deprecated
                _this.updateElement();
                var isValidByMethodName = function (name) { return ((_this === null || _this === void 0 ? void 0 : _this[name]) && loadEvent && (loadEventSource === null || loadEventSource === void 0 ? void 0 : loadEventSource.addEventListener)); };
                var timeLaunched = 0;
                loadEventSource.addEventListener(loadEvent, function () {
                    (++timeLaunched);
                    // todo: remove after deprecation and check retrocompatibility
                    // if (timeLaunched > 1 && loadEvent == "DOMContentLoaded") {
                    //   this.domRefresh$.next(timeLaunched);
                    // }
                    _this.updateElement();
                    if (_this.$element && isValidByMethodName('onLoad')) {
                        _this === null || _this === void 0 ? void 0 : _this.onLoad(_this.$element);
                    }
                    if (_this.$elements && isElementArray && isValidByMethodName('onLoadEach')) {
                        _this.$elements.forEach(function ($element) {
                            _this === null || _this === void 0 ? void 0 : _this.onLoadEach($element);
                        });
                    }
                }, loadEventOptions);
                return _this;
            }
            class_1.prototype.updateElement = function () {
                this.$element = window.$(selector);
                this.$elements = isElementArray ? window.$$(selector) : [this.$element];
                return this;
            };
            return class_1;
        }(Class));
    };
}
exports.DOMBlock = DOMBlock;
